import React, { Component } from 'react';
import Translate from 'react-translate-component';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { path } from 'ramda';
import { Form, Button } from 'antd';

import { education, experience, language, languageLevel, sex } from 'constants/dictionaries';
import { NATURAL_NUMBER } from 'constants/regexp';
import { RadioButtonsLoad } from 'components/common/form/RadioButtons';
import { SelectLoadComponent } from 'components/common/form/Select';
import InputNumberMask from 'components/common/form/InputNumberMask';
import Text from 'components/common/form/Text';
import { formItemLayout } from 'constants/formItemLayout';
import CustomIcon from 'components/common/CustomIcon';
import { maxLength, composeValidators } from 'utils/validators';

const lessThanAgeTo = (value, model) => {
    const to = path(['age', 'to'], model);
    return to && (+value > +to) ? <Translate content='errors.mustBeLessThan' with={{ value: to }} />  : undefined;
};

export default class RequirementsForm extends Component {
    renderLanguages({ fields }) {
        return (
            <div>
                { fields.map((field, index) =>
                    <div key={index} className="card-languages">
                        <Field name={`${field}.id`}
                               allowClear
                               component={SelectLoadComponent}
                               loadName={language}
                               placeholder={<Translate content='placeholders.chooseLanguage' />}
                               containerClass="card-languages-item"
                               notWrap={true}
                        />
                        { fields.value[index].id &&
                            <Field name={`${field}.level`}
                                   allowClear
                                   component={SelectLoadComponent}
                                   loadName={languageLevel}
                                   namePath='value'
                                   containerClass="card-languages-item"
                                   placeholder={<Translate content='placeholders.proficiency' />}
                                   onChange={() => !fields.value[index + 1] && index !== 2 ? fields.push({}) : null}
                                   notWrap={true}
                            />
                        }
                    </div>
                )}
                { !fields.length && (
                    <Button onClick={() => fields.push({})}>
                        <Translate content='common.add' />
                    </Button>
                )}
            </div>
        );
    }

    render () {
        return (
            <div className="card requirements-card">
                <div className="card-head">
                    <h3>
                        <CustomIcon type="list-ul"/>
                        <Translate content='request.headers.requirementsForCandidate' component='span' />
                    </h3>
                </div>
                <div className="card-body">
                    <Field name='requirement'
                           component={Text}
                           label={{ content: 'request.requirements' }}
                           placeholder='placeholders.enterExperienceRequirements'
                           validate={maxLength(1023)}
                    />

                    <Field name='responsibilities'
                           component={Text}
                           label={{ content: 'request.responsibilities' }}
                           placeholder='placeholders.enterResponsibilities'
                           validate={maxLength(1023)}
                    />

                    <Field name='education.level'
                           allowClear
                           component={SelectLoadComponent}
                           namePath='value'
                           loadName={education}
                           label={{ content: 'request.education' }}
                           placeholder={<Translate content='placeholders.chooseEducation' />} />

                    <Field name='education.comment'
                           component={Text}
                           label={{ content: 'request.educationComment' }}
                           placeholder='placeholders.enterEducationComment'
                           validate={maxLength(1023)}
                    />

                    <Field name='personality'
                           component={Text}
                           label={{ content: 'request.personalQualities' }}
                           placeholder='placeholders.enterPersonalQualities'
                           validate={maxLength(1023)}
                    />
                    <Form.Item label={<Translate content='common.languages'/>} {...formItemLayout}>
                        <FieldArray name='languages'>
                            { this.renderLanguages }
                        </FieldArray>
                    </Form.Item>
                    <Field name='sex'
                           component={RadioButtonsLoad}
                           loadName={sex}
                           namePath='value'
                           label={{ content: 'request.sex' }} />
                    <Form.Item label={<Translate content='request.age.title' />} {...formItemLayout}>
                        <Field name='age.from'
                               component={InputNumberMask}
                               mask={NATURAL_NUMBER}
                               placeholder='placeholders.from'
                               containerClass="inline"
                               validate={composeValidators(lessThanAgeTo, maxLength(3))}
                               notWrap={true}
                               className="age-from"
                        />
                        <Field name='age.to'
                               component={InputNumberMask}
                               mask={NATURAL_NUMBER}
                               placeholder='placeholders.to'
                               containerClass="inline"
                               notWrap={true}
                               notError={true}
                               className="age-to"
                               validate={maxLength(3)}
                        />
                    </Form.Item>
                    <Field name='experience'
                           allowClear
                           component={SelectLoadComponent}
                           namePath='value'
                           loadName={experience}
                           label={{ content: 'request.experience' }}
                           placeholder={<Translate content='placeholders.chooseExperience' />} />

                    <Field name='comment'
                           component={Text}
                           label={{ content: 'request.comment' }}
                           placeholder='placeholders.enterAdditionalInformation'
                           validate={maxLength(1023)}
                    />
                </div>
            </div>
        );
    }
}
